import { render, staticRenderFns } from "./janchr.vue?vue&type=template&id=163b7e1b&"
import script from "./janchr.vue?vue&type=script&lang=js&"
export * from "./janchr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports